import { Component, OnInit, Input } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../base/base.component';
import { Right } from 'src/app/classes/Right';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {

  @Input() sidenav: MatSidenav;
  currentLanguage: string;

  environmentName: string;
  constructor() {
    super();
  }

  ngOnInit() {
    this.currentLanguage = this.translationService.getLocale();
    this.environmentName = environment.name;
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  logout() {
    this.authorizationService.logout();
  }

  changeLanguage(changeEvent: MatButtonToggleChange) {
    this.translationService.setLocale(changeEvent.value);
    this.translationService.setDirection(changeEvent.value === "en_us" ? "ltr" : "rtl");
  }

}
